import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { App } from './App';
import { ApiAuthProvider } from './components/providers/ApiAuthProvider';
import { HeroUiProvider } from './components/providers/HeroUiProvider';
import { initializeDocumentTheme } from './lib/theme';
import { initializeDocumentTypography } from './lib/typography';
import './app.css';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY');

initializeDocumentTheme();
initializeDocumentTypography();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/sign-in">
      <ApiAuthProvider>
        <HeroUiProvider>
          <App />
        </HeroUiProvider>
      </ApiAuthProvider>
    </ClerkProvider>
  </StrictMode>,
);
